module.exports = __webpack_public_path__ + "img/sol_cap2.ce1a7d01.png";